<template>
  <div class="projects-medias-list">
    <v-row>
      <v-col
        v-for="n in medias.length"
        :key="n"
        class="d-flex child-flex"
        cols="4"
      >
        <v-img
          :src="`https://picsum.photos/200/300?image=${n * 5 + 10}`"
          :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
          aspect-ratio="1"
          class="grey lighten-2"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
      </v-col>
    </v-row>

    <v-btn color="green">
      Test
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "AppProjectsMediasList",

  data() {
    return {
      medias: []
    };
  },

  mounted() {
    this.getMediasFromDB();
  },

  methods: {
    async getMediasFromDB() {
      const projectUuid = this.$route.params.uuid;
      this.medias = await this.$db.medias
        .where({ project_uuid: projectUuid })
        .toArray();
    }
  }
};
</script>

<style></style>
